module.exports = {
  YEAR_SLASH_MONTH_OPTIONAL_SLASH_DAY: '([12]\\d{3})/(0[1-9]|1[0-2])(/(0[1-9]|[12][0-9]|3[01]))?',
  TEXT_WITHOUT_SLASH: '([^/]+)'
};